/* Tucano · Landing Halloween 26: torcia, countdown e aggiungi al carrello per le sezioni tcn-hw-* */
(function () {
  if (window.__hw26) return;
  window.__hw26 = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Torcia ---
  function initHero(hero) {
    if (hero.dataset.hwReady) return;
    hero.dataset.hwReady = '1';
    var sw = hero.querySelector('[data-hw-switch]');
    function fit() { hero.style.setProperty('--hw-top', Math.max(0, hero.getBoundingClientRect().top + window.scrollY) + 'px'); }
    fit(); window.addEventListener('resize', fit);
    function setLit(on) {
      hero.classList.toggle('is-lit', on);
      if (!sw) return;
      sw.setAttribute('aria-pressed', on ? 'true' : 'false');
      sw.textContent = on ? sw.dataset.off : sw.dataset.on;
    }
    if (reduce) setLit(true);
    if (sw) sw.addEventListener('click', function () { setLit(!hero.classList.contains('is-lit')); });
    function move(x, y) {
      var r = hero.getBoundingClientRect();
      hero.style.setProperty('--hw-x', (x - r.left) + 'px');
      hero.style.setProperty('--hw-y', (y - r.top) + 'px');
    }
    hero.addEventListener('pointermove', function (e) { move(e.clientX, e.clientY); hero.classList.add('is-hover'); });
    hero.addEventListener('pointerleave', function () { hero.classList.remove('is-hover'); });
  }

  // --- Countdown ---
  function initCount(c) {
    if (c.dataset.hwReady) return;
    c.dataset.hwReady = '1';
    var end = Date.parse(c.dataset.end);
    if (isNaN(end)) return;
    var el = { d: c.querySelector('[data-hw-d]'), h: c.querySelector('[data-hw-h]'), m: c.querySelector('[data-hw-m]'), s: c.querySelector('[data-hw-s]') };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var iv;
    function tick() {
      var t = Math.max(0, end - Date.now());
      var s = Math.floor(t / 1000);
      el.d.textContent = pad(Math.floor(s / 86400));
      el.h.textContent = pad(Math.floor(s % 86400 / 3600));
      el.m.textContent = pad(Math.floor(s % 3600 / 60));
      el.s.textContent = pad(s % 60);
      if (t <= 0 && iv) clearInterval(iv);
    }
    tick();
    iv = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-hw-hero]').forEach(initHero);
    document.querySelectorAll('[data-hw-count]').forEach(initCount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  // Editor del tema: sezioni aggiunte o ricaricate
  document.addEventListener('shopify:section:load', initAll);

  // --- Aggiungi al carrello (carrello laterale del sito) ---
  document.addEventListener('click', async function (e) {
    var b = e.target.closest && e.target.closest('[data-hw-atc]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var label = b.textContent; b.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      var r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.hwAtc), quantity: 1 }] }) });
      if (!r.ok) throw new Error('add');
      var cart = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json();
      var html = null;
      try { var j = await (await fetch(location.pathname + '?sections=tcn-cart-drawer&t=' + Date.now(), { cache: 'no-store' })).json(); html = j && j['tcn-cart-drawer']; } catch (_) {}
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'hw', data: { source: 'hw', itemCount: cart.item_count, sections: html ? { 'tcn-cart-drawer': html } : {} } } }));
      var d = document.querySelector('cart-drawer-component');
      setTimeout(function () { if (d && typeof d.open === 'function') { try { d.open(); } catch (_) {} } }, 250);
      b.textContent = '✓';
    } catch (_) { window.location.href = root + 'cart'; }
    setTimeout(function () { b.textContent = label; b.disabled = false; }, 1600);
  }, true);
})();
